import LocationsAutoSuggest from './LocationsAutoSuggest';
export default LocationsAutoSuggest;
